import { createFileRoute } from '@tanstack/react-router';
import { CalendarioRelatorio } from '@/modules/agronomia/components/CalendarioRelatorio';

// Tela 12 · Relatório consolidado (seletor de data) — fiel ao Figma.
export const Route = createFileRoute('/_authed/agronomia_/fazendas_/$id_/relatorio')({
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <CalendarioRelatorio imovelId={Number(id)} />;
}
